import { AuthLayout } from '@/components/layouts/AuthLayout'
import { CreateNewPassword } from '@/pages/forgotPassword/CreateNewPassword'
import { EnterOTP } from '@/pages/forgotPassword/EnterOTP'
import { ForgotPassword } from '@/pages/forgotPassword/ForgotPassword'
import { Login } from '@/pages/login/Login'
import { Route } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

export const AuthRoutes = () => {
  const navigate = useNavigate()

  return (
    <>
      <Route
        path="login"
        element={
          <AuthLayout>
            <Login
              onLinkClick={(arg) => {
                if (typeof arg === 'string') {
                  navigate(`/${arg}`)
                } else if (arg && typeof arg === 'object') {
                  navigate(`/${arg.page}`, arg.state ? { state: arg.state } : undefined)
                }
              }}
              onLoginSuccess={() => navigate('/campaigns')}
            />
          </AuthLayout>
        }
      />

      <Route path="forgot-password">
        <Route
          index
          element={
            <AuthLayout>
              <ForgotPassword
                onLinkClick={(page) => navigate(`/${page}`)}
                onSuccess={(email: string) => navigate('/forgot-password/enter-otp', { state: { email } })}
              />
            </AuthLayout>
          }
        />
        <Route
          path="enter-otp"
          element={
            <AuthLayout>
              <EnterOTP
                onLinkClick={(page) => navigate(`/${page}`)}
                onSuccess={(email: string) => navigate('/forgot-password/create-new-password', { state: { email } })}
              />
            </AuthLayout>
          }
        />
        <Route
          path="create-new-password"
          element={
            <AuthLayout>
              <CreateNewPassword onLinkClick={(page) => navigate(`/${page}`)} onSuccess={() => navigate('/campaigns')} />
            </AuthLayout>
          }
        />
      </Route>
    </>
  )
}
